
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import headerBackTitle from '@/components/header/headerBackTitleShare'
import share from '@/components/share/share'
export default {
components: {
share,
Flexbox,
FlexboxItem,
Divider,
XInput,
XButton,
XSwitch,
XTextarea,
headerBackTitle
},
data () {
return {


shareInfo:{},
zcnickname:decodeURIComponent(this.$route.params.zcnickname),
zcfoundation:decodeURIComponent(this.$route.params.zcfoundation)
}
},
methods: {
shareFn(){

if(this.isWeixinCient()){
this.showToast('','text','请点击右上角进行分享','20em','','')
}else{
console.log(this.shareInfo)
window.share.getShareDetailView(this.shareInfo);
}
},
goProjectDetail(){

if(this.$route.query.isShare){
if(this.$route.query.isShare=="share"){
this.$router.push('/zcprojectDetail/'+this.$route.params.projectId+'/'+this.$route.params.zcuserid+'/'+encodeURIComponent(this.$route.params.zcnickname)+'/'+this.$route.params.zctoken+'?isShare=share')
}
}else{
this.$router.push('/zcprojectDetail/'+this.$route.params.projectId+'/'+this.$route.params.zcuserid+'/'+encodeURIComponent(this.$route.params.zcnickname)+'/'+this.$route.params.zctoken)
}
},
wechatshareneedkey  () {
if(this.isWeixinCient()){
let lineLink=window.location.href.split('#')[0];
this.shareInfo = {
title : '荣誉证书' || '中国社会帮扶网',
desc: this.$route.params.acr002,

link : this.appjump_url+'/pages/index/#/zccertificate/'+encodeURIComponent(this.$route.params.acr002)+'/'+this.$route.params.donateTime+'/'+this.$route.params.projectId+'/'+this.$route.params.zcuserid+'/'+this.$route.params.zctoken+'/'+encodeURIComponent(this.$route.params.zcnickname)+'/'+this.$route.params.zcmoney+'/'+encodeURIComponent(this.$route.params.zcfoundation)+'?isShare=share',
imgUrl: this.appjump_url+'/pages/index/shareIcon/icon_9.png'
};
this.setWeixinConfig(this.shareInfo);
}else{
this.shareInfo = '{"picurl":"'+this.appjump_url+'/pages/index/shareIcon/icon_9.png'+'","title":"荣誉证书","type":"'+2+'","projectId":"'+this.$route.params.projectId+'","text":"'+this.$route.params.acr002+'","url":"'+this.appjump_url+'/pages/index/#/zccertificate/'+encodeURIComponent(this.$route.params.acr002)+'/'+this.$route.params.donateTime+'/'+this.$route.params.projectId+'/'+this.$route.params.zcuserid+'/'+this.$route.params.zctoken+'/'+encodeURIComponent(this.$route.params.zcnickname)+'/'+this.$route.params.zcmoney+'/'+encodeURIComponent(this.$route.params.zcfoundation)+'?isShare=share'+'","ischange":'+'"2"'+'}'
console.log(this.shareInfo)
}
}

},
mounted () {
console.log(window.location.href,'这是证书地址')
this.wechatshareneedkey()
},
computed: {
nickName () {






}
},
created() {
this.zcnickname = this.$route.params.zcnickname
console.log(this.zcnickname)

}

}



// WEBPACK FOOTER //
// ./src/crowd_fund/certificate.vue